import React from "react";
import PropTypes from "prop-types";

/**
 * Title
 *  - Title for GroupC
 */
export function Title(props) {
  return <p className={props.className}>{props.title}</p>;
}

Title.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   *  title for the group
   */
  title: PropTypes.string,
};

Title.defaultProps = {
  className: "",
};
